import React from "react";


function Top(props) {
  //let resol = window.screen.width+'x'+ window.screen.height;
  //<div className="resol">{resol}</div>
  return (
    <div className="flex w-full flex-row h-[7.5rem] space-x-3 items-center justify-center bg-light shadow-2xl shadow-border-stone-200 border-stone-200 ">
      <div className="flex w-[7.5rem] h-full text-center items-center justify-center">
        <img src={props.ruta} className ="w-[7rem] h-[7rem] rounded-full  shadow-lg shadow-border-stone-200 border border-stone-200 object-cover"></img>
      </div>
      <div className="flex flex-col h-full text-center items-center justify-center text-gray-700 ">
        <div className="text-[1.5rem] font-semibold text-shadow-lg/20">{props.empresa.NombreTerc}</div>
        <div className="text-[1.4rem] font-bold text-shadow-lg/20">{props.areas.NombreArea}</div>
      </div>
    </div>
  );
}

export default Top;
